import axios from 'axios';

import { Filter } from './Filter';
import { GetToken } from './Session';

export function GetUserById(id) {
	return axios.get('/api/v1/users/' + id, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function CreateUser(data) {
	return axios.post('/api/v1/users', data, { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetCurrentUser() {
	return axios.get('/api/v1/me', { headers: { Authorization: 'Bearer ' + GetToken().access_token } })
}

export function GetXlsxUser(q) {
	return axios.get('/api/v1/xlsx_users' + Filter(q), { headers: { Authorization: 'Bearer ' + GetToken().access_token }, responseType: 'blob' })
}